// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntityBaseSize-Mc2EntityBaseSizeModal-module__content--Jsjnf {
  min-height: 120px;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntityBaseSize-Mc2EntityBaseSizeModal-module__label--QD7NE {
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.55);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntityBaseSize-Mc2EntityBaseSizeModal-module__list--UdxLo {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsMeasurementChart2/Mc2Summary/Mc2Entity/Mc2EntityBaseSize/Mc2EntityBaseSizeModal.module.less"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;AAEA;EACE,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAAF;AAGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AADF","sourcesContent":[".content {\n  min-height: 120px;\n}\n\n.label {\n  margin-bottom: 8px;\n  color: rgba(0, 0, 0, 0.55);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n}\n\n.list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntityBaseSize-Mc2EntityBaseSizeModal-module__content--Jsjnf`,
	"label": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntityBaseSize-Mc2EntityBaseSizeModal-module__label--QD7NE`,
	"list": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2EntityBaseSize-Mc2EntityBaseSizeModal-module__list--UdxLo`
};
export default ___CSS_LOADER_EXPORT___;
